var _rect, _circle, _circle2, _path, _path2, _path3, _circle3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimCompanyRejectIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.61523,
    y: 3.87109,
    width: 26.8869,
    height: 33.3397,
    fill: "#256AF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0581,
    cy: 6.23776,
    r: 6.23776,
    fill: "#256AF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0575,
    cy: 6.23714,
    r: 2.36605,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.207 15.0547H23.058",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.207 21.832H30.909",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.207 28.6094H30.909",
    stroke: "white",
    strokeWidth: 2.30769
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.95177,
    cy: 30.0006,
    r: 9.08654,
    fill: "#E7614F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6753 27.2734L7.22656 32.7221M12.6753 32.7227L7.22656 27.2739",
    stroke: "white",
    strokeWidth: 2.30769,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCompanyRejectIc);
export default __webpack_public_path__ + "static/media/claim-company-reject-ic.e5019a8616a3bccc769d165a570ecb60.svg";
export { ForwardRef as ReactComponent };